import React, { memo, useReducer, useMemo, useEffect } from 'react';
import queryString from "query-string";
import { useHistory } from "react-router-dom";

import { conditionIndexMap } from '../data/vehicle';

export const TradeDataContext = React.createContext();

function convertQueryStrToTradeInState(queryStr = '') {
  const {
    a: accessoriesStr = "",
    c: condition,
    o: singleOwner,
    m: miles,
    i: interestedVehicleStr = "",
    d: date,
    v: tradeInValues = '',
    ov: ownedVin,
    vin,
    interest,
    leadId
  } = queryString.parse(queryStr);

  const accessoryIds = accessoriesStr.split(",");
  const ymmt = ['yearId', 'makeId', 'modelId', 'trimId'];
  const interestedVehicle = interestedVehicleStr
    .split(',')
    .filter(i => i)
    .reduce(
      (vehicle, value, i) => {
        vehicle[ymmt[i]] = value;
        return vehicle;
      },
      { vin: interest || vin }
    );

  return {
    leadId,
    miles,
    vin: ownedVin,
    singleOwner: Boolean(singleOwner),
    condition: conditionIndexMap[condition] || condition,
    accessoryIds,
    interestedVehicle,
    date,
    tradeInValues: tradeInValues.split(','),
  };
}

/**
 * Given a certain trade in state will return an url query.
 * @param {*} state
 * @returns string ?stateKey=stateValue;
 */
export function tradeInStateToQueryStr(state) {
  const { interestedVehicle } = state;
  const { vin, yearId, makeId, modelId, trimId } = interestedVehicle;
  return '?' + [
    { key: 'leadId', value: state.leadId },
    { key: 'a', value: state.accessoryIds.join(',') },
    { key: 'm', value: state.miles },
    { key: 'c', value: state.condition },
    { key: 'vin', value: vin },
    { key: 'o', value: state.singleOwner },
    { key: 'd', value: state.date },
    { key: 'v', value: state.tradeInValues.join(',') },
    { key: 'i', value: (yearId && makeId && modelId) && `${yearId},${makeId},${modelId},${trimId}` },
    { key: 'ov', value: state.vin }
  ]
  .map(({ key, value }) => value && `${key}=${value}`)
  .filter(i => i)
  .join('&');
};

function reducer(state, action) {
  const { prop } = action;
  return { ...state, ...prop };
}

const initState = convertQueryStrToTradeInState(window.location.search)

function TradeData({ children }) {
  const history = useHistory();

  const [trade, dispatch] = useReducer(reducer, initState);
  const data = useMemo(() => ([ trade, dispatch ]), [trade, dispatch]);

  const search = useMemo(function createQueryFromState() {
    return tradeInStateToQueryStr(trade);
  }, [trade]);

  useEffect(function syncHistoryWithState() {
    if (history.location.search.replace('?', '') !== search.replace('?', '')) {
      history.replace(`${history.location.pathname}${search}`, {});
    }
  }, [search, history]);

  return (
    <TradeDataContext.Provider value={data}>
      {children}
    </TradeDataContext.Provider>
  );
}

export default memo(TradeData);
